module.exports = __webpack_public_path__ + "img/beltegoed.b2e0227.png";